export default {"src":"/_next/static/media/impelement-security.0a7e5afb.svg","height":28,"width":23,"blurWidth":0,"blurHeight":0};